import React, { useEffect, useRef, useState } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { FaTimes } from "react-icons/fa";
import { FORUM, TRANSITION } from "../Theme/styles";

const SecretVideo = ({ word = "parowa", src = "/parowa.mp4", volume = 1 }) => {
  const [open, setOpen] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    if (open && videoRef.current) videoRef.current.volume = volume;
  }, [open, volume]);

  useEffect(() => {
    let typed = "";

    const onKey = (e) => {
      if (e.key === "Escape") {
        setOpen(false);
        return;
      }

      const target = e.target;
      const tag = target && target.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || target?.isContentEditable) {
        return;
      }
      if (e.ctrlKey || e.altKey || e.metaKey) return;
      if (e.key.length !== 1) return;

      typed = (typed + e.key.toLowerCase()).slice(-word.length);
      if (typed === word) {
        typed = "";
        setOpen(true);
      }
    };

    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [word]);

  if (!open) return null;

  return (
    <Flex
      position={"fixed"}
      inset={0}
      align={"center"}
      justify={"center"}
      bg={"rgba(0,0,0,0.75)"}
      zIndex={2000}
      p={4}
      onClick={() => setOpen(false)}
    >
      <Box position={"relative"} maxW={"860px"} w={"100%"} onClick={(e) => e.stopPropagation()}>
        <Box
          as={"button"}
          position={"absolute"}
          top={"-32px"}
          right={0}
          color={FORUM.tekstPrzygaszony}
          transition={TRANSITION}
          _hover={{ color: FORUM.tekstJasny }}
          onClick={() => setOpen(false)}
          aria-label={"Zamknij"}
        >
          <FaTimes size={18} />
        </Box>
        <video
          ref={videoRef}
          src={src}
          autoPlay
          controls
          loop
          style={{ width: "100%", borderRadius: "12px", display: "block" }}
        />
      </Box>
    </Flex>
  );
};

export default SecretVideo;
